module.exports = function() {
  return new Worker("/" + "babel-transpiler.2b848fc1.worker.js");
};